import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementWorkRequestStatusAddComponent } from './case-management-work-request-status-add.component';

const routes: Routes = [{ path: '', component: CaseManagementWorkRequestStatusAddComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementWorkRequestStatusAddRoutingModule { }
